import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200 shrink-0"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "text-sm text-slate-500"
};
const _hoisted_4 = {
  class: "overflow-y-auto flex-1 min-h-0"
};
const _hoisted_5 = {
  class: "px-6 py-3 bg-slate-50 border-b border-slate-200 flex items-center gap-3"
};
const _hoisted_6 = {
  key: 0,
  class: "px-2 py-0.5 bg-amber-100 text-amber-700 rounded text-xs"
};
const _hoisted_7 = {
  class: "p-6"
};
const _hoisted_8 = {
  class: "mb-6"
};
const _hoisted_9 = {
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
};
const _hoisted_10 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_11 = {
  class: "font-medium text-slate-900"
};
const _hoisted_12 = {
  class: "bg-slate-50 rounded-lg p-3 sm:col-span-2"
};
const _hoisted_13 = {
  key: 0,
  class: "flex items-start gap-3"
};
const _hoisted_14 = {
  class: "min-w-0 flex-1"
};
const _hoisted_15 = {
  class: "font-medium text-slate-900 truncate"
};
const _hoisted_16 = {
  class: "mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2"
};
const _hoisted_17 = {
  class: "flex items-center gap-1.5 min-w-0 text-xs text-slate-600"
};
const _hoisted_18 = {
  class: "text-slate-700 truncate"
};
const _hoisted_19 = {
  class: "flex items-center gap-1.5 min-w-0 text-xs text-slate-600"
};
const _hoisted_20 = {
  class: "text-slate-700 truncate"
};
const _hoisted_21 = {
  key: 1,
  class: "flex items-center gap-2 text-sm text-slate-400"
};
const _hoisted_22 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_23 = {
  class: "font-medium text-primary-600"
};
const _hoisted_24 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_25 = {
  class: "font-medium text-slate-900"
};
const _hoisted_26 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_27 = {
  class: "font-medium text-primary-600"
};
const _hoisted_28 = {
  class: "mb-6"
};
const _hoisted_29 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_30 = {
  class: "prose prose-sm max-w-none text-slate-600"
};
const _hoisted_31 = {
  key: 0,
  class: "mb-6"
};
const _hoisted_32 = {
  key: 1,
  class: "mb-6"
};
const _hoisted_33 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_34 = {
  class: "text-sm text-slate-600"
};
const _hoisted_35 = {
  class: "mb-6"
};
const _hoisted_36 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_37 = {
  class: "space-y-4"
};
const _hoisted_38 = {
  class: "bg-slate-50 px-4 py-3 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_39 = {
  class: "flex items-center gap-3"
};
const _hoisted_40 = {
  class: "font-medium text-slate-900"
};
const _hoisted_41 = {
  class: "text-xs text-slate-500"
};
const _hoisted_42 = {
  class: "flex items-center gap-2 shrink-0"
};
const _hoisted_43 = ["onClick"];
const _hoisted_44 = ["onClick"];
const _hoisted_45 = {
  class: "p-4"
};
const _hoisted_46 = {
  class: "grid grid-cols-2 md:grid-cols-5 gap-4 mb-4"
};
const _hoisted_47 = {
  class: "text-sm text-slate-900"
};
const _hoisted_48 = {
  class: "text-sm text-slate-900"
};
const _hoisted_49 = {
  class: "text-sm font-medium text-primary-600"
};
const _hoisted_50 = {
  class: "text-sm text-slate-900"
};
const _hoisted_51 = {
  class: "text-sm text-slate-600"
};
const _hoisted_52 = {
  key: 0,
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_53 = {
  class: "data-table-shell"
};
const _hoisted_54 = {
  class: "data-table-scroll"
};
const _hoisted_55 = {
  class: "data-table text-sm"
};
const _hoisted_56 = {
  class: "data-table-td text-slate-900"
};
const _hoisted_57 = {
  class: "data-table-td text-right font-medium text-slate-900"
};
const _hoisted_58 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_59 = {
  class: "data-table-td text-center"
};
const _hoisted_60 = {
  class: "data-table-td text-right text-slate-600"
};
const _hoisted_61 = {
  class: "space-y-3"
};
const _hoisted_62 = {
  class: "flex-1"
};
const _hoisted_63 = {
  class: "flex items-center gap-2"
};
const _hoisted_64 = {
  class: "font-medium text-slate-900"
};
const _hoisted_65 = {
  key: 0,
  class: "text-xs px-2 py-0.5 bg-blue-100 text-blue-700 rounded"
};
const _hoisted_66 = {
  key: 1,
  class: "text-xs px-2 py-0.5 bg-slate-100 text-slate-700 rounded"
};
const _hoisted_67 = {
  key: 0,
  class: "text-sm text-slate-600 mt-1"
};
const _hoisted_68 = {
  class: "text-xs text-slate-400 mt-1"
};
const _hoisted_69 = {
  key: 0,
  class: "text-center py-4 text-slate-500 text-sm"
};
const _hoisted_70 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-between gap-3 shrink-0"
};
const _hoisted_71 = {
  key: 1
};
const _hoisted_72 = {
  class: "p-6"
};
const _hoisted_73 = {
  class: "mb-6 p-4 bg-slate-50 rounded-lg space-y-2"
};
const _hoisted_74 = {
  class: "flex items-center gap-3"
};
const _hoisted_75 = {
  class: "text-sm text-slate-900"
};
const _hoisted_76 = {
  key: 0,
  class: "flex items-center gap-3"
};
const _hoisted_77 = {
  class: "text-sm text-slate-900"
};
const _hoisted_78 = {
  key: 1,
  class: "flex items-center gap-3"
};
const _hoisted_79 = {
  class: "flex items-center gap-2"
};
const _hoisted_80 = {
  class: "w-6 h-6 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center text-white text-xs font-medium"
};
const _hoisted_81 = {
  class: "text-sm text-slate-900"
};
const _hoisted_82 = {
  key: 2,
  class: "flex items-center gap-3"
};
const _hoisted_83 = {
  class: "text-sm text-slate-900"
};
const _hoisted_84 = {
  key: 3,
  class: "flex items-center gap-3"
};
const _hoisted_85 = {
  class: "text-sm text-slate-900"
};
const _hoisted_86 = {
  class: "flex items-center gap-3 w-full"
};
const _hoisted_87 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_88 = ["disabled"];
const _hoisted_89 = {
  class: "p-6"
};
const _hoisted_90 = {
  class: "text-lg font-medium text-slate-900"
};
const _hoisted_91 = {
  class: "text-slate-600"
};
const _hoisted_92 = {
  class: "text-amber-600 font-medium"
};
const _hoisted_93 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_94 = ["disabled"];
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getPlanDetail, cancelPlan } from '@/api/plan';
import { getOrderDetail } from '@/api/order';
import { receiveBilling } from '@/api/billing';
import { updateTask } from '@/api/task';
import { getTraceList } from '@/api/trace';
import AppModal from '@/components/AppModal.vue';
import ApprovalDetailModal from '@/components/ApprovalDetailModal.vue';
import FileAttachment from '@/components/FileAttachment.vue';
import OrderDetailModal from '@/components/OrderDetailModal.vue';
import OrderFormModal from '@/components/OrderFormModal.vue';
export default {
  __name: 'PlanDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    planId: {
      type: [String, Number],
      default: null
    },
    planData: {
      type: Object,
      default: null
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const planDetail = ref(null);
    const traceList = ref([]);
    const hasReferrer = computed(() => Boolean(planDetail.value?.referrer?.id || planDetail.value?.referrer?.name));
    const hasPlanRemark = computed(() => Boolean(String(planDetail.value?.remark || '').trim()));

    // 订单创建相关
    const showOrderForm = ref(false);

    // 订单详情查看
    const showOrderDetail = ref(false);
    const orderDetail = ref(null);
    const orderTraceList = ref([]);
    const orderDetailLoading = ref(false);
    const showOrderApprovalModal = ref(false);
    const orderApprovalInstanceId = ref(null);

    // 订单编辑相关
    const showOrderEditModal = ref(false);
    const editOrderData = ref(null);

    // 账单收款相关
    const showBillingReceiveModal = ref(false);
    const selectedBilling = ref(null);
    const receiveFormRef = ref(null);
    const receiveSubmitting = ref(false);
    const receiveFormData = reactive({
      paidAmount: 0,
      payChannel: ''
    });
    const receiveRules = {
      paidAmount: [{
        required: true,
        message: '请输入收款金额',
        trigger: 'blur'
      }, {
        validator: (rule, value, callback) => {
          if (!value || value <= 0) {
            callback(new Error('收款金额必须大于0'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      payChannel: [{
        required: true,
        message: '请选择支付渠道',
        trigger: 'change'
      }]
    };
    const payChannelOptions = [{
      label: '微信',
      value: 'WECHAT'
    }, {
      label: '支付宝',
      value: 'ALIPAY'
    }, {
      label: '银行转账',
      value: 'BANK_TRANSFER'
    }, {
      label: '现金',
      value: 'CASH'
    }, {
      label: '其他',
      value: 'OTHER'
    }];
    const receiveRemainingAmount = computed(() => {
      if (!selectedBilling.value) return 0;
      return (selectedBilling.value.amount || 0) - (selectedBilling.value.paidAmount || 0);
    });

    // 任务编辑相关
    const showTaskEditModal = ref(false);
    const selectedTask = ref(null);
    const taskFormRef = ref(null);
    const taskSubmitting = ref(false);
    const taskFormData = reactive({
      status: 0,
      progress: 0,
      remark: ''
    });
    const taskRules = {
      status: [{
        required: true,
        message: '请选择任务状态',
        trigger: 'change'
      }],
      progress: [{
        required: true,
        message: '请输入任务进度',
        trigger: 'blur'
      }, {
        type: 'number',
        min: 0,
        max: 100,
        message: '进度必须在0-100之间',
        trigger: 'blur'
      }]
    };

    // 状态映射
    const statusMap = {
      0: {
        text: '草稿',
        class: 'bg-slate-100 text-slate-600'
      },
      1: {
        text: '执行中',
        class: 'bg-blue-100 text-blue-700'
      },
      2: {
        text: '已完成',
        class: 'bg-green-100 text-green-700'
      },
      3: {
        text: '已取消',
        class: 'bg-red-100 text-red-700'
      },
      4: {
        text: '待审批',
        class: 'bg-amber-100 text-amber-700'
      }
    };
    const orderStatusMap = {
      '-1': {
        text: '待审批',
        class: 'bg-amber-100 text-amber-700'
      },
      0: {
        text: '待确认',
        class: 'bg-slate-100 text-slate-600'
      },
      1: {
        text: '执行中',
        class: 'bg-blue-100 text-blue-700'
      },
      2: {
        text: '已完成',
        class: 'bg-green-100 text-green-700'
      },
      3: {
        text: '已取消',
        class: 'bg-red-100 text-red-700'
      },
      4: {
        text: '已驳回',
        class: 'bg-orange-100 text-orange-700'
      }
    };
    const billingStatusMap = {
      0: {
        text: '待收',
        class: 'bg-amber-100 text-amber-700'
      },
      1: {
        text: '已收',
        class: 'bg-green-100 text-green-700'
      },
      2: {
        text: '部分收',
        class: 'bg-blue-100 text-blue-700'
      },
      3: {
        text: '已核销',
        class: 'bg-purple-100 text-purple-700'
      }
    };
    const getStatusClass = status => statusMap[status]?.class || 'bg-slate-100 text-slate-600';
    const getStatusText = status => statusMap[status]?.text || '未知';
    const getOrderStatusClass = status => orderStatusMap[status]?.class || 'bg-slate-100 text-slate-600';
    const getOrderStatusText = status => orderStatusMap[status]?.text || '未知';
    const getBillingStatusClass = status => billingStatusMap[status]?.class || 'bg-slate-100 text-slate-600';
    const getBillingStatusText = status => billingStatusMap[status]?.text || '未知';
    const formatDateTime = date => {
      if (!date) return '-';
      return new Date(date).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    };
    const loadData = async () => {
      // 检查是否已有完整数据（包含 customer 和 orders）
      const hasFullData = props.planData?.customer && props.planData?.orders?.length > 0;
      if (hasFullData) {
        // 如果传递了完整数据，直接使用
        planDetail.value = props.planData;
      } else {
        // 需要获取完整数据
        const id = props.planData?.id || props.planId;
        if (!id) {
          console.warn('没有方案ID，无法加载详情');
          return;
        }
        try {
          planDetail.value = await getPlanDetail(id);
        } catch (error) {
          console.error('加载方案详情失败', error);
          return;
        }
      }

      // 加载轨迹记录
      if (planDetail.value?.id) {
        try {
          traceList.value = await getTraceList('PLAN', planDetail.value.id);
        } catch (error) {
          console.error('加载轨迹记录失败', error);
        }
      }
    };
    const closeModal = () => {
      emit('update:visible', false);
    };

    // 打开订单表单
    const openOrderForm = () => {
      showOrderForm.value = true;
    };

    // 打开订单详情
    const openOrderDetail = async order => {
      if (!order?.id || orderDetailLoading.value) return;
      orderDetailLoading.value = true;
      try {
        const [detail, traces] = await Promise.all([getOrderDetail(order.id), getTraceList('ORDER', order.id).catch(() => [])]);
        orderDetail.value = detail;
        orderTraceList.value = traces || [];
        showOrderDetail.value = true;
      } catch (error) {
        console.error('加载订单详情失败', error);
        ElMessage.error('加载订单详情失败');
      } finally {
        orderDetailLoading.value = false;
      }
    };

    // 查看订单审批详情
    const handleOrderApprovalDetail = order => {
      if (!order?.pendingApprovalInstanceId) {
        ElMessage.warning('暂无审批实例');
        return;
      }
      orderApprovalInstanceId.value = order.pendingApprovalInstanceId;
      showOrderApprovalModal.value = true;
    };

    // 刷新订单详情（收款、任务、执行人等变更后），并同步刷新方案数据
    const refreshOrderDetail = async () => {
      if (!orderDetail.value?.id) return;
      try {
        orderDetail.value = await getOrderDetail(orderDetail.value.id);
        orderTraceList.value = await getTraceList('ORDER', orderDetail.value.id);
      } catch (error) {
        ElMessage.error(error?.message || '刷新订单详情失败');
      }
      loadData();
    };

    // 从详情弹窗编辑订单
    const handleOrderDetailEdit = order => {
      editOrderData.value = order;
      showOrderDetail.value = false;
      showOrderEditModal.value = true;
    };
    const isAmountApprovalInProgress = order => {
      return Number(order?.pendingApprovalStatus) === 0 && order?.pendingApprovalInstanceId != null;
    };

    // 订单编辑成功
    const handleOrderEditSuccess = async result => {
      ElMessage.success(isAmountApprovalInProgress(result) ? '已提交订单金额变更审批，审批通过后生效' : '订单修改成功');
      showOrderEditModal.value = false;
      await loadData();
    };

    // 打开收款弹窗
    const openOrderReceiveModal = billing => {
      selectedBilling.value = billing;
      receiveFormData.paidAmount = receiveRemainingAmount.value;
      receiveFormData.payChannel = '';
      showBillingReceiveModal.value = true;
    };
    const closeOrderReceiveModal = () => {
      showBillingReceiveModal.value = false;
    };

    // 提交收款
    const handleOrderReceiveSubmit = async () => {
      try {
        await receiveFormRef.value.validate();
      } catch {
        return;
      }
      receiveSubmitting.value = true;
      try {
        await receiveBilling({
          billingId: selectedBilling.value.id,
          paidAmount: receiveFormData.paidAmount,
          payChannel: receiveFormData.payChannel
        });
        ElMessage.success('收款成功');
        closeOrderReceiveModal();
        await refreshOrderDetail();
      } catch (error) {
        ElMessage.error(error?.message || '收款失败');
      } finally {
        receiveSubmitting.value = false;
      }
    };

    // 打开任务编辑弹窗
    const openOrderTaskEditModal = task => {
      selectedTask.value = task;
      taskFormData.status = task.status ?? 0;
      taskFormData.progress = task.progress || 0;
      taskFormData.remark = task.remark || '';
      showTaskEditModal.value = true;
    };
    const closeOrderTaskEditModal = () => {
      showTaskEditModal.value = false;
      if (taskFormRef.value) {
        taskFormRef.value.resetFields();
      }
    };

    // 任务状态改为已完成时，自动将进度同步为 100%
    const handleTaskStatusChange = val => {
      if (val === 2 && taskFormData.progress < 100) {
        taskFormData.progress = 100;
      }
    };

    // 提交任务编辑
    const handleOrderTaskSubmit = async () => {
      try {
        await taskFormRef.value.validate();
      } catch {
        return;
      }
      taskSubmitting.value = true;
      try {
        await updateTask({
          id: selectedTask.value.id,
          orderId: selectedTask.value.orderId,
          status: taskFormData.status,
          progress: taskFormData.progress,
          remark: taskFormData.remark
        });
        ElMessage.success('任务更新成功');
        closeOrderTaskEditModal();
        await refreshOrderDetail();
      } catch (error) {
        ElMessage.error(error?.message || '任务更新失败');
      } finally {
        taskSubmitting.value = false;
      }
    };

    // 取消方案
    const handleCancelPlan = async () => {
      try {
        await ElMessageBox.confirm('确定要取消此方案吗？取消后将删除方案下的所有订单和账单，此操作不可恢复。', '取消方案', {
          confirmButtonText: '确定取消',
          cancelButtonText: '我再想想',
          type: 'warning',
          confirmButtonClass: 'el-button--danger'
        });
        await cancelPlan(planDetail.value.id);
        ElMessage.success('方案已取消');

        // 关闭弹窗并通知父组件刷新
        emit('update:visible', false);
        emit('success');
      } catch (error) {
        if (error === 'cancel') {
          // 用户点击了取消按钮，不做任何操作
          return;
        }
        ElMessage.error(error.message || '取消方案失败');
      }
    };
    watch(() => props.visible, val => {
      if (val) {
        loadData();
      } else {
        planDetail.value = null;
        traceList.value = [];
        showOrderDetail.value = false;
        orderDetail.value = null;
        orderTraceList.value = [];
        showOrderApprovalModal.value = false;
        orderApprovalInstanceId.value = null;
        showOrderEditModal.value = false;
        editOrderData.value = null;
        showTaskEditModal.value = false;
        selectedTask.value = null;
        showBillingReceiveModal.value = false;
        selectedBilling.value = null;
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_slider = _resolveComponent("el-slider");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_safe_html = _resolveDirective("safe-html");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(OrderFormModal, {
        visible: showOrderForm.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => showOrderForm.value = $event),
        planId: planDetail.value?.id,
        onSuccess: loadData
      }, null, 8, ["visible", "planId"]), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.visible,
        size: "5xl",
        onClose: _cache[1] || (_cache[1] = $event => _ctx.$emit('update:visible', false))
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, _toDisplayString(planDetail.value?.name), 1), _createElementVNode("p", _hoisted_3, "方案编号: " + _toDisplayString(planDetail.value?.planNo), 1)]), _createElementVNode("button", {
          onClick: closeModal,
          class: "p-1.5 text-slate-400 hover:text-slate-600"
        }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", {
          class: _normalizeClass(['px-3 py-1 rounded-full text-sm font-medium', getStatusClass(planDetail.value?.status)])
        }, _toDisplayString(getStatusText(planDetail.value?.status)), 3), planDetail.value?.needApproval ? (_openBlock(), _createElementBlock("span", _hoisted_6, "待审批")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[23] || (_cache[23] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "基本信息", -1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "客户", -1)), _createElementVNode("div", _hoisted_11, _toDisplayString(planDetail.value?.customer?.name || '-'), 1)]), _createElementVNode("div", _hoisted_12, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-2"
        }, "引入人", -1)), hasReferrer.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[17] || (_cache[17] = _createElementVNode("div", {
          class: "w-9 h-9 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center shrink-0"
        }, [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17 20h5v-2a4 4 0 00-4-4h-1M9 20H4v-2a4 4 0 014-4h1m0-4a4 4 0 118 0 4 4 0 01-8 0z"
        })])], -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(planDetail.value.referrer.name || '-'), 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_cache[13] || (_cache[13] = _createElementVNode("svg", {
          class: "w-3.5 h-3.5 text-slate-400 shrink-0",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M3 5a2 2 0 012-2h2.28a1 1 0 01.95.68l1.1 3.29a1 1 0 01-.5 1.2l-1.52.76a11.04 11.04 0 005.76 5.76l.76-1.52a1 1 0 011.2-.5l3.29 1.1a1 1 0 01.68.95V19a2 2 0 01-2 2h-1C8.82 21 3 15.18 3 8V5z"
        })], -1)), _cache[14] || (_cache[14] = _createElementVNode("span", {
          class: "text-slate-400 shrink-0"
        }, "手机号", -1)), _createElementVNode("span", _hoisted_18, _toDisplayString(planDetail.value.referrer.phone || '-'), 1)]), _createElementVNode("div", _hoisted_19, [_cache[15] || (_cache[15] = _createElementVNode("svg", {
          class: "w-3.5 h-3.5 text-slate-400 shrink-0",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.42-4.03 8-9 8a9.77 9.77 0 01-4-.84L3 20l1.24-3.1A7.4 7.4 0 013 12c0-4.42 4.03-8 9-8s9 3.58 9 8z"
        })], -1)), _cache[16] || (_cache[16] = _createElementVNode("span", {
          class: "text-slate-400 shrink-0"
        }, "微信号", -1)), _createElementVNode("span", _hoisted_20, _toDisplayString(planDetail.value.referrer.wechat || '-'), 1)])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[18] || (_cache[18] = [_createElementVNode("div", {
          class: "w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center"
        }, [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M18 9v3m0 0v3m0-3h3m-3 0h-3M9 7a4 4 0 100 8 4 4 0 000-8zM3 21a6 6 0 0112 0"
        })])], -1), _createElementVNode("span", null, "暂无引入人", -1)]))]))]), _createElementVNode("div", _hoisted_22, [_cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "方案金额", -1)), _createElementVNode("div", _hoisted_23, "¥" + _toDisplayString(planDetail.value?.totalAmount?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_24, [_cache[21] || (_cache[21] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "优惠金额", -1)), _createElementVNode("div", _hoisted_25, "¥" + _toDisplayString(planDetail.value?.discount?.toLocaleString() || '0'), 1)]), _createElementVNode("div", _hoisted_26, [_cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "text-xs text-slate-500 mb-1"
        }, "应付金额", -1)), _createElementVNode("div", _hoisted_27, "¥" + _toDisplayString(planDetail.value?.payableAmount?.toLocaleString() || '0'), 1)])])]), _createElementVNode("div", _hoisted_28, [_cache[24] || (_cache[24] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "方案详情", -1)), _createElementVNode("div", _hoisted_29, [_withDirectives(_createElementVNode("div", _hoisted_30, null, 512), [[_directive_safe_html, planDetail.value?.detailContent || '-']])])]), planDetail.value?.attachments?.length ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_cache[25] || (_cache[25] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "方案附件", -1)), _createVNode(FileAttachment, {
          files: planDetail.value.attachments
        }, null, 8, ["files"])])) : _createCommentVNode("", true), hasPlanRemark.value ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_cache[26] || (_cache[26] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "备注", -1)), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(planDetail.value.remark), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_cache[28] || (_cache[28] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700"
        }, "订单明细", -1)), planDetail.value?.status === 1 ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: openOrderForm,
          class: "px-3 py-1.5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 text-sm flex items-center gap-1.5"
        }, [...(_cache[27] || (_cache[27] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 新增订单 ", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planDetail.value?.orders, order => {
          return _openBlock(), _createElementBlock("div", {
            key: order.id,
            class: "border border-slate-200 rounded-lg overflow-hidden"
          }, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("span", _hoisted_40, _toDisplayString(order.productNameSnapshot), 1), _createElementVNode("span", _hoisted_41, _toDisplayString(order.productCodeSnapshot), 1), _createElementVNode("span", {
            class: _normalizeClass(['px-2 py-0.5 rounded text-xs font-medium', order.orderType === 'ONCE' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'])
          }, _toDisplayString(order.orderType === 'ONCE' ? '一次性服务' : `分期服务（${order.periodCount}期）`), 3)]), _createElementVNode("div", _hoisted_42, [_createElementVNode("button", {
            type: "button",
            class: "table-action-button is-primary",
            title: "查看订单详情",
            "aria-label": "查看订单详情",
            onClick: $event => openOrderDetail(order)
          }, [...(_cache[29] || (_cache[29] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_43), order.pendingApprovalInstanceId != null ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "table-action-button is-purple",
            title: "查看审批详情",
            "aria-label": "查看审批详情",
            onClick: $event => handleOrderApprovalDetail(order)
          }, [...(_cache[30] || (_cache[30] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          })], -1)]))], 8, _hoisted_44)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: _normalizeClass(['px-2 py-0.5 rounded text-xs font-medium', getOrderStatusClass(order.status)])
          }, _toDisplayString(getOrderStatusText(order.status)), 3)])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "订单编号", -1)), _createElementVNode("div", _hoisted_47, _toDisplayString(order.orderNo), 1)]), _createElementVNode("div", null, [_cache[32] || (_cache[32] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "服务周期", -1)), _createElementVNode("div", _hoisted_48, _toDisplayString(order.serviceStart) + " ~ " + _toDisplayString(order.serviceEnd), 1)]), _createElementVNode("div", null, [_cache[33] || (_cache[33] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "订单金额", -1)), _createElementVNode("div", _hoisted_49, "¥" + _toDisplayString(order.amount?.toLocaleString() || '0'), 1)]), _createElementVNode("div", null, [_cache[34] || (_cache[34] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "落地执行人员", -1)), _createElementVNode("div", _hoisted_50, _toDisplayString(order.executor?.displayName || order.executor?.username || '-'), 1)]), _createElementVNode("div", null, [_cache[35] || (_cache[35] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "备注", -1)), _createElementVNode("div", _hoisted_51, _toDisplayString(order.remark || '-'), 1)])]), order.billings && order.billings.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_cache[37] || (_cache[37] = _createElementVNode("div", {
            class: "flex items-center gap-2 mb-2"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
          })]), _createElementVNode("span", {
            class: "text-sm font-medium text-slate-700"
          }, "账单明细")], -1)), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("table", _hoisted_55, [_cache[36] || (_cache[36] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th"
          }, "期次"), _createElementVNode("th", {
            class: "px-3 py-2 text-right text-xs font-medium text-slate-500"
          }, "应收金额"), _createElementVNode("th", {
            class: "data-table-th"
          }, "应收日期"), _createElementVNode("th", {
            class: "px-3 py-2 text-center text-xs font-medium text-slate-500"
          }, "状态"), _createElementVNode("th", {
            class: "px-3 py-2 text-right text-xs font-medium text-slate-500"
          }, "已收")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.billings, billing => {
            return _openBlock(), _createElementBlock("tr", {
              key: billing.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_56, "第" + _toDisplayString(billing.periodIndex) + "期", 1), _createElementVNode("td", _hoisted_57, "¥" + _toDisplayString(billing.amount?.toLocaleString()), 1), _createElementVNode("td", _hoisted_58, _toDisplayString(billing.dueDate), 1), _createElementVNode("td", _hoisted_59, [_createElementVNode("span", {
              class: _normalizeClass(['status-badge', getBillingStatusClass(billing.status)])
            }, _toDisplayString(getBillingStatusText(billing.status)), 3)]), _createElementVNode("td", _hoisted_60, "¥" + _toDisplayString(billing.paidAmount?.toLocaleString() || '0'), 1)]);
          }), 128))])])])])])) : _createCommentVNode("", true)])]);
        }), 128))])]), _createElementVNode("div", null, [_cache[39] || (_cache[39] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "操作记录", -1)), _createElementVNode("div", _hoisted_61, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(traceList.value, trace => {
          return _openBlock(), _createElementBlock("div", {
            key: trace.id,
            class: "flex items-start gap-3 p-3 bg-slate-50 rounded-lg"
          }, [_cache[38] || (_cache[38] = _createElementVNode("div", {
            class: "w-8 h-8 bg-primary-100 text-primary-600 rounded-full flex items-center justify-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          })])], -1)), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("span", _hoisted_64, _toDisplayString(trace.title || trace.action), 1), trace.traceType === 'STATUS' ? (_openBlock(), _createElementBlock("span", _hoisted_65, "状态变更")) : (_openBlock(), _createElementBlock("span", _hoisted_66, "备注"))]), trace.content ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(trace.content), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_68, _toDisplayString(trace.operatorName) + " · " + _toDisplayString(formatDateTime(trace.createTime)), 1)])]);
        }), 128)), traceList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_69, " 暂无操作记录 ")) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_70, [planDetail.value?.status === 1 ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: handleCancelPlan,
          class: "px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700"
        }, " 取消方案 ")) : (_openBlock(), _createElementBlock("div", _hoisted_71)), _createElementVNode("button", {
          onClick: closeModal,
          class: "px-5 py-2.5 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200"
        }, "关闭")])]),
        _: 1
      }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(OrderDetailModal, {
        visible: showOrderDetail.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = $event => showOrderDetail.value = $event),
        orderDetail: orderDetail.value,
        traceList: orderTraceList.value,
        onReceive: openOrderReceiveModal,
        onEditTask: openOrderTaskEditModal,
        onEdit: handleOrderDetailEdit,
        onApprovalDetail: handleOrderApprovalDetail,
        onRefreshDetail: refreshOrderDetail,
        onExecutorChanged: refreshOrderDetail
      }, null, 8, ["visible", "orderDetail", "traceList"])])), _createVNode(OrderFormModal, {
        visible: showOrderEditModal.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => showOrderEditModal.value = $event),
        isEdit: true,
        editData: editOrderData.value,
        onSuccess: handleOrderEditSuccess
      }, null, 8, ["visible", "editData"]), _createVNode(ApprovalDetailModal, {
        modelValue: showOrderApprovalModal.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => showOrderApprovalModal.value = $event),
        "instance-id": orderApprovalInstanceId.value,
        type: "order",
        title: "审批详情"
      }, null, 8, ["modelValue", "instance-id"]), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: showTaskEditModal.value,
        size: "2xl",
        "z-index": 60,
        onClose: closeOrderTaskEditModal
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
        }, [_cache[41] || (_cache[41] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "编辑任务", -1)), _createElementVNode("button", {
          onClick: closeOrderTaskEditModal,
          class: "p-1.5 text-slate-400 hover:text-slate-600"
        }, [...(_cache[40] || (_cache[40] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_cache[42] || (_cache[42] = _createElementVNode("span", {
          class: "text-sm font-medium text-slate-500 w-20"
        }, "任务名称", -1)), _createElementVNode("span", _hoisted_75, _toDisplayString(selectedTask.value?.name), 1)]), selectedTask.value?.type ? (_openBlock(), _createElementBlock("div", _hoisted_76, [_cache[43] || (_cache[43] = _createElementVNode("span", {
          class: "text-sm font-medium text-slate-500 w-20"
        }, "任务类型", -1)), _createElementVNode("span", _hoisted_77, _toDisplayString(selectedTask.value?.type), 1)])) : _createCommentVNode("", true), selectedTask.value?.assigneeName ? (_openBlock(), _createElementBlock("div", _hoisted_78, [_cache[44] || (_cache[44] = _createElementVNode("span", {
          class: "text-sm font-medium text-slate-500 w-20"
        }, "负责人", -1)), _createElementVNode("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, _toDisplayString(selectedTask.value?.assigneeName?.charAt(0)), 1), _createElementVNode("span", _hoisted_81, _toDisplayString(selectedTask.value?.assigneeName), 1)])])) : _createCommentVNode("", true), selectedTask.value?.startTime ? (_openBlock(), _createElementBlock("div", _hoisted_82, [_cache[45] || (_cache[45] = _createElementVNode("span", {
          class: "text-sm font-medium text-slate-500 w-20"
        }, "开始时间", -1)), _createElementVNode("span", _hoisted_83, _toDisplayString(formatDateTime(selectedTask.value?.startTime)), 1)])) : _createCommentVNode("", true), selectedTask.value?.endTime ? (_openBlock(), _createElementBlock("div", _hoisted_84, [_cache[46] || (_cache[46] = _createElementVNode("span", {
          class: "text-sm font-medium text-slate-500 w-20"
        }, "结束时间", -1)), _createElementVNode("span", _hoisted_85, _toDisplayString(formatDateTime(selectedTask.value?.endTime)), 1)])) : _createCommentVNode("", true)]), _createVNode(_component_el_form, {
          ref_key: "taskFormRef",
          ref: taskFormRef,
          model: taskFormData,
          rules: taskRules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "任务状态",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: taskFormData.status,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => taskFormData.status = $event),
              placeholder: "请选择任务状态",
              class: "w-full",
              onChange: handleTaskStatusChange
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "待开始",
                value: 0
              }), _createVNode(_component_el_option, {
                label: "进行中",
                value: 1
              }), _createVNode(_component_el_option, {
                label: "已完成",
                value: 2
              }), _createVNode(_component_el_option, {
                label: "已暂停",
                value: 3
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "任务进度",
            prop: "progress"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_86, [_createVNode(_component_el_slider, {
              modelValue: taskFormData.progress,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => taskFormData.progress = $event),
              min: 0,
              max: 100,
              class: "flex-1"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_input_number, {
              modelValue: taskFormData.progress,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => taskFormData.progress = $event),
              min: 0,
              max: 100,
              class: "w-25"
            }, null, 8, ["modelValue"]), _cache[47] || (_cache[47] = _createElementVNode("span", {
              class: "text-slate-600"
            }, "%", -1))])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "remark"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: taskFormData.remark,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => taskFormData.remark = $event),
              type: "textarea",
              rows: 4,
              placeholder: "请输入备注信息"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]), _createElementVNode("div", _hoisted_87, [_createElementVNode("button", {
          onClick: closeOrderTaskEditModal,
          class: "px-5 py-2.5 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200"
        }, "取消"), _createElementVNode("button", {
          disabled: taskSubmitting.value,
          onClick: handleOrderTaskSubmit,
          class: "px-5 py-2.5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50"
        }, _toDisplayString(taskSubmitting.value ? '保存中...' : '保存'), 9, _hoisted_88)])]),
        _: 1
      }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: showBillingReceiveModal.value,
        size: "md",
        "z-index": 60,
        onClose: closeOrderReceiveModal
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
        }, [_cache[49] || (_cache[49] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "账单收款", -1)), _createElementVNode("button", {
          onClick: closeOrderReceiveModal,
          class: "p-1.5 text-slate-400 hover:text-slate-600"
        }, [...(_cache[48] || (_cache[48] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_89, [_createVNode(_component_el_form, {
          ref_key: "receiveFormRef",
          ref: receiveFormRef,
          model: receiveFormData,
          rules: receiveRules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "应收金额"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_90, "¥" + _toDisplayString(selectedBilling.value?.amount?.toLocaleString()), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "已收金额"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_91, "¥" + _toDisplayString(selectedBilling.value?.paidAmount?.toLocaleString() || '0'), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "待收金额"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_92, "¥" + _toDisplayString(receiveRemainingAmount.value.toLocaleString()), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "收款金额",
            prop: "paidAmount"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: receiveFormData.paidAmount,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => receiveFormData.paidAmount = $event),
              min: 0.01,
              max: receiveRemainingAmount.value,
              precision: 2,
              step: 100,
              class: "w-50"
            }, null, 8, ["modelValue", "max"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "支付渠道",
            prop: "payChannel"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: receiveFormData.payChannel,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => receiveFormData.payChannel = $event),
              placeholder: "请选择支付渠道",
              class: "w-50"
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(payChannelOptions, channel => {
                return _createVNode(_component_el_option, {
                  key: channel.value,
                  label: channel.label,
                  value: channel.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]), _createElementVNode("div", _hoisted_93, [_createElementVNode("button", {
          onClick: closeOrderReceiveModal,
          class: "px-5 py-2.5 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200"
        }, "取消"), _createElementVNode("button", {
          disabled: receiveSubmitting.value,
          onClick: handleOrderReceiveSubmit,
          class: "px-5 py-2.5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50"
        }, "确认收款", 8, _hoisted_94)])]),
        _: 1
      }, 8, ["visible"])]))], 64);
    };
  }
};